import { render } from "./createdMe.vue?vue&type=template&id=8f50c0f2"
import script from "./createdMe.vue?vue&type=script&lang=js"
export * from "./createdMe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__